const s = {
  name: "CashBack",
  dimensions: { width: 40, height: 22 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 22" style="enable-background:new 0 0 40 22;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24.5,6c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5s5-2.2,5-5C29.5,8.2,27.3,6,24.5,6z M21.5,11c0-1.7,1.3-3,3-3
			s3,1.3,3,3c0,1.7-1.3,3-3,3S21.5,12.7,21.5,11z"/>
		<path class="st0" d="M13,4h5v2h-3v3h-2V4z"/>
		<path class="st0" d="M15,13v3h3v2h-5v-5H15z"/>
		<path class="st0" d="M34,16v-3h2v5h-5v-2H34z"/>
		<path class="st0" d="M31,6h3v3h2V4h-5V6z"/>
		<path class="st0" d="M9,0h31v22H9V0z M11,2v18h27V2H11z"/>
		<path class="st0" d="M5.7,5.3l1.4,1.4L2.8,11l4.3,4.3l-1.4,1.4L0,11L5.7,5.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CashBack
};
